/**
 * @param {T[]} list
 * @param {Function<T,U>} getValue
 * @return {T[]}
 */
export function dedup<T, U>(list: T[], getValue: (item: T) => U): T[] {
  const ids: any = {};
  return list.filter((item) => {
    const value = getValue(item);
    return !ids[value] && (ids[value] = true);
  });
}

/**
 * @param {number} length desired list length
 * @return {undefined[]} list with desired list length
 */
export function getList(length: number): undefined[] {
  const list = [];
  for (let i = 0; i < length; i++) {
    list.push(undefined);
  }
  return list;
}

export type Pair<T> = {
  p1: T;
  p2: T;
};

/**
 * Partitions a list into two random sublists
 * @param {T[]} list
 * @return {Pair<T[]>}
 */
export function getRandomSublists<T>(list: T[]): Pair<T[]> {
  const l1: T[] = [];
  const l2: T[] = [];
  list.forEach((item) => {
    if (Math.random() > 0.5) {
      l1.push(item);
    } else {
      l2.push(item);
    }
  });
  return { p1: l1, p2: l2 };
}

/**
 * Gets a page from a list
 * @param {T[]} list
 * @param {number} pageNumber
 * @param {number} pageSize
 * @return {T[]}
 */
export function getPage<T>(
  list: T[],
  pageNumber: number,
  pageSize: number
): T[] {
  return list.slice(pageNumber * pageSize, (pageNumber + 1) * pageSize);
}
